import React, { useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col
} from "reactstrap";
import DemoFundManualTable from "../table/all-tables/fundtable/DemoFundManualTable";
import DemoAccFundedtable from "../table/all-tables/fundedtable/DemoAccFundedtable";
import "./fund.scss";
import { fundedInvoicesData } from "../../locales/en";
import { STATUS_1 } from "../../utils/constants/appConstants";

function DemoAccountFund() {
  const [activeTab, setActiveTab] = useState(STATUS_1);
  const [apiHit, setApiHit] = useState(null);
  const handleSendActive = () => {
    setApiHit((prev) => !prev);
  };
  return (
    <div className="invoice-tab-wrap">
      <div className="container">
        <Nav tabs className="invoice-nav">
          <NavItem>
            <NavLink
              className={activeTab === "1" ? "active" : ""}
              onClick={() => setActiveTab("1")}
            >
              {fundedInvoicesData.toFund.toFundNav}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "2" ? "active" : ""}
              onClick={() => setActiveTab("2")}
            >
              {fundedInvoicesData.funded.fundedNav}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab} id="invoice-tabcontent">
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <div className="fundtable-wrap">
                  <DemoFundManualTable
                    setActiveTab={setActiveTab}
                    handleSendActive={handleSendActive}
                  />
                </div>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                <DemoAccFundedtable apiHit={apiHit} />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
}

export default DemoAccountFund;
